// Enums matching backend
export enum RoleOrgAccessLevel {
    Custom = 0,
    Agg = 1,
    Full = 1000,
}

export enum OrgLevelType {
    Individual = 0,
    Team = 1,
    Group = 2,
}

// Roles
export type ApiRole = {
    id: string;
    name: string;
    roleOrgAccessType: RoleOrgAccessLevel;
    ownTeamAgg: boolean;
    orgDataAccessTree: AccessGroupNode[];
};

export type ResponseGetRoles = {
    roles: ApiRole[];
};

export type ResponseGetRole = ApiRole;

export type ResponseCreateRole = ApiRole;

export type RequestCreateRole = {
    name: string;
    roleOrgAccessType: RoleOrgAccessLevel;
    ownTeamAgg: boolean;
    orgDataAccessTree: AccessGroupNode[];
};

export type RequestUpdateRole = RequestCreateRole;

// Access (UI types)
export type AccessGroupNode = {
    id: string;
    name: string;
    orgLevelType: OrgLevelType;
    isSelected: boolean;
    includeAllIndividuals: boolean;
    includeAllChildGroups: boolean;
    children: AccessGroupNode[];
};

export type AccessLevel = RoleOrgAccessLevel | undefined;

// Module access
export type ApiPermission = {
    id: string;
    name: string;
    defaultValue: number;
    valueDefinitions: Record<string, string>;
};

export type ResponseGetRolePermissions = {
    rolePermissions: Record<string, number>;
    permissions: ApiPermission[];
};
